import React, { useState, useEffect } from 'react';
import { Box, Link, SpaceBetween } from "@amzn/awsui-components-react"
import { FRISCO_STATUS } from "../Frisco/Constants"
import { isApprover, isRippleApprover, isUploaderAllowed } from '../Frisco/AccessUtilities';

export const getStateNonAdmin = (item) => {
    if (item?.current_status == FRISCO_STATUS.COMPLETED || item?.current_status == FRISCO_STATUS.COMPLETE_NOTIFIED
        || item?.current_status == FRISCO_STATUS.PREPARING_DATA_FOR_APPROVAL || item?.current_status == FRISCO_STATUS.DATA_PREPARED_FOR_APPROVAL
        || item?.current_status == FRISCO_STATUS.DATA_PREPARING_FOR_APPROVAL || item?.current_status == FRISCO_STATUS.ADMIN_APPROVAL_PENDING
        || item?.current_status == FRISCO_STATUS.ADMIN_APPROVAL_COMPLETE || item?.current_status == FRISCO_STATUS.MOVED_TO_FDV 
        || item?.current_status == 'MOVING_TO_FDV' || item?.current_status == FRISCO_STATUS.SHARED_TO_CATALOG
        || item?.current_status == FRISCO_STATUS.CATALOG_DATA_WRITE_COMPLETE || item?.current_status == FRISCO_STATUS.REPORTING_CENTRAL_APPROVAL_STATUS_SUCCESS
        || item?.current_status == FRISCO_STATUS.REPORTING_CENTRAL_APPROVAL_STATUS_PENDING || item?.current_status == FRISCO_STATUS.SHARING_TO_CATALOG
        || item?.current_status == FRISCO_STATUS.REPORTING_CENTRAL_APPROVAL_STATUS_REQUESTED) {
        return <Box><span className='green_badge small_badge'>COMPLETE</span></Box>
    } else {
        return <Box><span className='red_badge small_badge'>INCOMPLETE</span></Box>
    }
    
}

export const getStateNonAdminPlain = (item) => {
    if(item?.overall_status == "INCOMPLETE"){
        return <Box><span className='red_badge small_values'>INCOMPLETE</span></Box>
    }else if(item.overall_status == "PENDING"){
        return <Box><span className='orange_badge small_values'>PENDING</span></Box>
    }else if(item.overall_status == "COMPLETED"){
        return <Box><span className='green_badge small_values'>COMPLETED</span></Box>
            
    }else{
        return <Box><span className='red_badge small_values'>INCOMPLETE</span></Box>
           
    }
}

export function convertToLocalTime(value, showTimezone = false) {
  try {
    const options = {
      year: 'numeric',
      month: 'numeric',
      day: 'numeric',
      hour: 'numeric',
      minute: '2-digit',
      hour12: true,
      ...(showTimezone && { timeZoneName: 'short' })
    };
    
    return new Date(value).toLocaleString("en-US", options);
  } catch (error) {
    return value;
  }
}

export function convertToPST(value) {
    try {
        return new Date(value).toLocaleString("en-US", {
            timeZone: "America/Los_Angeles",
            year: 'numeric',
            month: 'numeric',
            day: 'numeric',
            hour: 'numeric',
            minute: '2-digit',
            hour12: true
        });
    } catch (error) {
        return value;
    }
}
export const getLocaleToPST = (value) => {
    console.log(value)
    return convertToPST(value)
}

function getLocaleStringPST(value){
    const options = {
        year: 'numeric',
        month: 'numeric',
        day: 'numeric',
        hour: 'numeric',
        minute: '2-digit',
        hour12: true
    };
    const date = new Date(value);
    const formattedDate = date.toLocaleString('en-US', options);
    return formattedDate
}

export const showDueDatesTable = (date, time) => {
    if (!date || date.includes('aN')) return null;
    const utcString = `${date}T${time || '00:00'}`;
    let formattedDate = getLocaleStringPST(utcString)
    return (
        <Box><span className="small_values">{formattedDate}</span></Box>
    );
};

export const showGenericDatesTable = (value) => {
    if (!value || value.includes('aN')) return null;
    let formattedDate = getLocaleStringPST(value)
    return (
        <Box><span className="small_values">{formattedDate}</span></Box>
    );
};

export const showGenericDatesTableInfo = (value) => {
    if (!value || value.includes('aN')) return null;
    let formattedDate = getLocaleStringPST(value)
    return (
        <Box><span className="small_values info_message">{formattedDate}</span></Box>
    );
};

export function renderStatus(renderData, serviceType, isClickAllowed) {
    if (renderData == null) {
        return <></>
    }
    let redirectUrl = renderData.file_id?`/${serviceType}/file/${renderData.file_id}`: null
    let renderElement = <span className='small_values'>{renderData?.current_status}</span>
    if (renderData?.overall_status == "INCOMPLETE") {
        renderElement = <span className='red_text small_values'>{renderData.current_status}</span>
    } else if (renderData?.overall_status == "PENDING") {
        renderElement = <span className='orange_text small_values'>{renderData.current_status}</span>
    } else if (renderData?.overall_status == "COMPLETED") {
        renderElement = <span className='green_text small_values'>{renderData.current_status}</span>
    } 
    if(isClickAllowed && renderData.file_id && redirectUrl){
       renderElement = <a href={redirectUrl} target="_blank">{renderElement}</a>
    }

    return renderElement
}

export function renderStatusWithLastUpdatedTime(renderData, serviceType, isClickAllowed) {
    if (renderData == null) {
        return <></>
    }
    let redirectUrl = renderData.file_id?`/${serviceType}/file/${renderData.file_id}`: null
    let renderElement = <span className='small_values'>{renderData?.current_status}</span>
    if (renderData?.overall_status == "INCOMPLETE") {
        renderElement = <span className='red_text small_values'>{renderData.current_status}</span>
    } else if (renderData?.overall_status == "PENDING") {
        renderElement = <span className='orange_text small_values'>{renderData.current_status}</span>
    } else if (renderData?.overall_status == "COMPLETED") {
        renderElement = <span className='green_text small_values'>{renderData.current_status}</span>
    } 
    if(isClickAllowed && renderData.file_id && redirectUrl){
       renderElement = <a  href={redirectUrl}>{renderElement}</a>
    }

    return <Box>
        <SpaceBetween direction='vertical' size='xxs'>
        {renderElement}
        {renderData.last_updated_time_stamp && showGenericDatesTableInfo(renderData.last_updated_time_stamp)}
    </SpaceBetween>
    </Box>
}

export function getStatusForMultipleStatus(data, keys){
let result = { 'overall_status': '', 'current_status': '', 'fileId': null }
let isDisabled = (data?.custom_attributes?.find(
            attr => attr.attribute_type === "DISABLED"
        )?.attribute || "false") === "true";
    if(isDisabled){
        return result
    }
    if (data?.hasOwnProperty('track_details')) {
        let details = null
        for (let i = 0; i < keys?.length; i++) {
            if (data?.track_details?.hasOwnProperty(keys[i])) {
                details = data.track_details[keys[i]]
                if(result?.last_updated_time_stamp && details.last_updated_time_stamp 
                    && new Date(result?.last_updated_time_stamp) > new Date(details.last_updated_time_stamp)){
                        continue
                }
                result = { 'overall_status': details?.overall_status, 'current_status': details?.current_status, 'file_id': details.file_id, 'last_updated_time_stamp': details.last_updated_time_stamp, 'uploaded_by': details.uploaded_by, 'wb_type': keys[i], 'tracking_id': details.tracking_id }
            }
        }
    }
    return result
}

export function getStatus(data, type) {
    let result = { 'overall_status': '', 'current_status': '', 'fileId': null }
    let isDisabled = (data?.custom_attributes?.find(
            attr => attr.attribute_type === "DISABLED"
        )?.attribute || "false") === "true";
    if(isDisabled){
        return result
    }
    if (data?.hasOwnProperty('track_details') && data.track_details?.hasOwnProperty(type)) {
        let details = data.track_details?.[type]
        result = { 'overall_status': details?.overall_status, 'current_status': details?.current_status, 'file_id': details?.file_id, 'last_updated_time_stamp': details?.last_updated_time_stamp, 'uploaded_by': details?.uploaded_by, 'wb_type': type, 'tracking_id': details?.tracking_id } 
    }
    return result
}

export function getWBStatusBasedOnCustomAttributes(data, mainWBType){
    if (mainWBType == 'PostWB') {
        let isNoPostWbDueDate = (data?.custom_attributes?.find(
            attr => attr.attribute_type === "NO_POST_WB_DUE_DATE"
        )?.attribute || "false") === "true";
        if (isNoPostWbDueDate) {
            return ['NoPostWB']
        } else {
            return ['PostWB', 'NoPostWB']
        }
    } else {
        let isNoPreWbDueDate = (data?.custom_attributes?.find(
            attr => attr.attribute_type === "NO_PRE_WB_DUE_DATE"
        )?.attribute || "false") === "true";
        if (isNoPreWbDueDate) {
            return ['NoPreWB']
        } else {
            return ['PreWB']
        }
    }
}

export function getOneWBStatusBasedOnCustomAttributes(data, mainWBType){
    if (mainWBType == 'PostWB') {
        let isNoPostWbDueDate = (data?.custom_attributes?.find(
            attr => attr.attribute_type === "NO_POST_WB_DUE_DATE"
        )?.attribute || "false") === "true";
        if (isNoPostWbDueDate) {
            return ['NoPostWB']
        } else {
            return ['PostWB']
        }

    } else {
        let isNoPreWbDueDate = (data?.custom_attributes?.find(
            attr => attr.attribute_type === "NO_PRE_WB_DUE_DATE"
        )?.attribute || "false") === "true";
        if (isNoPreWbDueDate) {
            return ['NoPreWB']
        } else {
            return ['PreWB']
        }
    }
}


export const getLatestTrackingDetails = (data) => {
    if (data?.hasOwnProperty('track_details') && data.track_details) {
        return Object.values(data.track_details)
            .filter(item => item.file_id !== null)  // Filter items with non-null file_id
            .reduce((latest, current) => {
                if (!latest) return current;  // If it's the first valid item
                return new Date(current.last_updated_time_stamp) > new Date(latest.last_updated_time_stamp)
                    ? current
                    : latest;
            }, null);  // Start with null as initial value
    } else {
        return null
    }
}

const getUniqueAlias = (aliasList) => {
    if(aliasList){
        let tempSet = new Set()
        let aliasSet = []
        aliasList.forEach((aliasItem) => {
            if(aliasItem && !tempSet.has(aliasItem.alias)){
                tempSet.add(aliasItem.alias)
                aliasSet.push(aliasItem)
            }
        })
        return aliasSet
    }
}

export const groupModules = (res, resGroups) => {
    let groupSet = {'status':{}, 'uploaders':{}, 'approvers':{}}
    res.forEach(item => {
        let status = item.overall_status
        if (!groupSet['status'][item.group_id]) {
            groupSet['status'][item.group_id] = []
        }
        if (status) {
            groupSet['status'][item.group_id].push(status.toUpperCase())
        }
        if (!groupSet['approvers'][item.group_id]) {
            groupSet['approvers'][item.group_id] = []
        }
        if (!groupSet['uploaders'][item.group_id]) {
            groupSet['uploaders'][item.group_id] = []
        }
        
        let temp = groupSet['approvers'][item.group_id]
        let approverAliasArr = getUniqueAlias(temp.concat(item?.approvers))
        temp = groupSet['uploaders'][item.group_id]
        let uploaderAliasArr = getUniqueAlias(temp.concat(item?.uploaders))
        groupSet['approvers'][item.group_id] = approverAliasArr
        groupSet['uploaders'][item.group_id] = uploaderAliasArr
    })

    for (let i = 0; i < resGroups.length; i++) {
        if (groupSet['status'][resGroups[i].group_id].length == 0) {
            resGroups[i]['consolidated_status'] = "INCOMPLETE"
        } else {
            if (groupSet['status'][resGroups[i].group_id].includes("INCOMPLETE") || groupSet['status'][resGroups[i].group_id].includes("PENDING")) {
                resGroups[i]['consolidated_status'] = "INCOMPLETE"
            } else {
                resGroups[i]['consolidated_status'] = "COMPLETED"
            }
        }

        resGroups[i]['approvers'] = groupSet['approvers'][resGroups[i].group_id]
        resGroups[i]['uploaders'] = groupSet['uploaders'][resGroups[i].group_id]
    }
    return resGroups
}
export const filterItemsByAccess = async (groups, filteringText, filteringKey, filters , currentStage, userLDAPS=null,
    onResult=null) => {
    let fGroups = []
    for(let i =0;i<groups.length;i++){
        // if (groups[i][filteringKey]?.toLowerCase().includes(filteringText.toLowerCase())) {
            if(filters && filters.length > 0){
                let canUpload = await isUploaderAllowed(groups[i], filters[0].label, currentStage=='dev'?'beta':currentStage, userLDAPS) 
                let canApprove = false
                if(!canUpload){
                    canApprove = await isApprover(groups[i], filters[0].label, currentStage=='dev'?'beta':currentStage, userLDAPS)
                }
                if(!canApprove){
                    canApprove = await isRippleApprover(groups[i], filters[0].label, currentStage=='dev'?'beta':currentStage, userLDAPS)
                }
                
                if(canUpload || canApprove ){
                    fGroups.push(groups[i])
                    if(onResult){
                        onResult(fGroups, false)
                    }
                }
            // }else{
            //     fGroups.push(groups[i])
            //     if(onResult){
            //         onResult(fGroups, false)
            //     }
            // }
        }
    }
    onResult(fGroups, true)
    
    return fGroups
}

export const getCurrentQuarter = () => {
    var today = new Date();
    console
    switch(today.getMonth()){
        case 0: 
        case 1: 
        case 2: 
            return "Q1"
        case 3: 
        case 4: 
        case 5: 
            return "Q2"
        case 6: 
        case 7: 
        case 8: 
            return "Q3"
        case 9: 
        case 10: 
        case 11: 
            return "Q4"
    }
}


export const getQuarterForUpload = () => {
    var today = new Date();
    console
    switch(today.getMonth()){
        case 0: 
        case 1: 
        case 2: 
            return `Q4 ${today.getFullYear()-1}`
        case 3: 
        case 4: 
        case 5: 
            return `Q1 ${today.getFullYear()}`
        case 6: 
        case 7: 
        case 8: 
            return `Q2 ${today.getFullYear()}`
        case 9: 
        case 10: 
        case 11: 
            return `Q3 ${today.getFullYear()}`
    }
}

export const validateMandatoryRestrictions = (data, dueDateKeys, ignoreKeys=[]) => {
    if (data?.hasOwnProperty('disabled') && JSON.parse(data?.disabled ?? 'false')) {
        return;
    }
    for (let key in dueDateKeys) {
        const value = data?.[dueDateKeys[key]?.['ui_keys']?.['no_wb_due_date']] ?? 'false';
        if (!ignoreKeys.includes(key) && !JSON.parse(value)) {
            return;
        }
    }
    throw Error("An active deliverable should have AT LEAST ONE active deliverable type")
}